import { m } from "@/paraglide/messages";
import type { Tool } from "../index";

export const vennDiagramTool: Tool = {
  id: "venn-diagram",
  name: () => m.venn_tool_name(),
  description: () => m.venn_tool_description(),
  icon: "⭕",
  basePath: "/venn-diagram",
  status: "stable",
  tags: [
    "chart",
    "plot",
    "data-visualization",
    "venn-diagram",
    "sets",
    "science",
  ],
};
